module.exports = __webpack_public_path__ + "static/24-8e34e2257f00aee1baef66e62633d958.jpg";